import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

const applicationServerKey = 'BDvSWov7z-IKx3-Ri4zdg6q8dNCu2PsFxELYX4lSO3E3R27_SEvfeTDSVv6E1ev_sVxDGTNf_v1IQSV2RggqSm0';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// service-worker.js — Workbox-скомпилированный SW, регистрируется при загрузке App.vue
async function getRegistration() {
  if (!('serviceWorker' in navigator)) return null;
  const reg = await navigator.serviceWorker.getRegistration('/service-worker.js');
  if (!reg) {
    console.warn('Service Worker not registered yet');
  }
  return reg;
}

export async function subscribeUserToPush() {
  if (!('Notification' in window)) return;

  const reg = await getRegistration();
  if (!reg) return;

  await navigator.serviceWorker.ready;
  if (Notification.permission !== 'granted') {
    console.warn('Permission for notifications was denied');
    return;
  }
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(applicationServerKey),
  });

  const data = {
    registration_id: sub.endpoint,
    p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(sub.getKey('p256dh')))),
    auth: btoa(String.fromCharCode.apply(null, new Uint8Array(sub.getKey('auth')))),
  };

  const endpoint = `${backendUrl}/api/notifications/web-push/push/web/`;
  await fetchWithAuth(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function unsubscribeUserFromPush() {
  const reg = await getRegistration();
  if (!reg?.pushManager) {
    console.warn('Push manager not available');
    return;
  }

  const sub = await reg.pushManager.getSubscription();
  if (!sub) {
    console.warn('No push subscription found');
    return;
  }

  const endpoint = `${backendUrl}/api/notifications/unsubscribe-web-push/`;
  await fetchWithAuth(endpoint, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ registration_id: sub.endpoint }),
  });
}

export async function checkPushSubscription() {
  if (!window.Notification || Notification.permission !== 'granted') {
    return false;
  }

  const reg = await getRegistration();
  if (!reg?.pushManager) {
    console.warn('Push manager not available');
    return false;
  }

  const sub = await reg.pushManager.getSubscription();
  if (!sub) {
    console.warn('No push subscription found');
    return false;
  }

  const endpoint = `${backendUrl}/api/notifications/check-web-push-subscription/?registration_id=${encodeURIComponent(sub.endpoint)}`;
  const response = await fetchWithAuth(endpoint, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    console.error('Failed to check push subscription:', response.statusText);
    return false;
  }

  const data = await response.json();
  return data?.subscribed ?? false;
}
